import { useEffect, useState } from 'react'

export const useLoadingAny = (loadings: boolean[]) => {
  const [loadingAny, setIsLoadingAny] = useState<boolean>(false);

  useEffect(() => {
    const loading = loadings.some(bool => bool);

    setIsLoadingAny(loading);
  }, loadings);

  return loadingAny;
}
